import {
  convertDateToUTC,
  parseFilterValue,
  parseSkuIds,
} from "../lib/helpers";
import { DashboardFilters } from "../lib/types";

export const convertFiltersToQueryParams = (filters: DashboardFilters) => ({
  from_datetime: convertDateToUTC(filters.from_datetime),
  to_datetime: convertDateToUTC(filters.to_datetime),
  journeys_count: parseFilterValue(filters?.journeys_count),
  order_source: parseFilterValue(filters.order_source),
  stage_journey_annotation: parseFilterValue(filters.stage_journey_annotation),
  stage_transaction_annotation: parseFilterValue(
    filters.stage_transaction_annotation
  ),
  stage_track_persistence_annotation: parseFilterValue(
    filters.stage_track_persistence_annotation
  ),
  annotator_id: parseFilterValue(filters.annotator_id),
  sku_ids: parseSkuIds(filters.sku_ids),
  order_id: parseFilterValue(filters.order_id),
});
